// TRANG KHO ẢNH (05/10/2026, menu Dữ liệu): Boss tải ảnh lên (nhiều tệp một lần — kéo-thả hoặc chọn tệp; JPG/PNG/WebP; trình duyệt tự thu nhỏ
// ≤ 1024 px, ≤ 283 KB như ảnh sản phẩm), xem lưới, chú thích, album, nhãn, xoá (hỏi lại; ảnh đang được kịch bản chọn → hỏi lần nữa, nêu tên kịch bản),
// tìm theo chú thích / tên tệp / nhãn, lọc album / sản phẩm / nhãn. Ảnh sản phẩm cũ hiện chung như album "Sản phẩm: <tên>" (chỉ sửa chú thích).
// Bước bình luận / trả lời chọn ảnh từ đây (chon-anh.ts). Super thấy ảnh của mọi Boss (lọc theo tài khoản).
// Tải lên: MỘT ảnh / yêu cầu, mỗi tệp một mã yêu cầu → bấm Tải 2 lần / Thử lại sau mất mạng không nhân đôi; cùng nội dung đã có → báo "đã có trong kho".
import { api, ApiError, buildQuery, errMsg } from "../api";
import { busy, clear, confirmBox, gen, h, toast } from "../dom";
import { fmtTime } from "../format";
import { store } from "../store";
import { thuNhoAnh } from "./san-pham";
import { kbChu, tenHienAnh, type AnhKhoWeb, type NhomKho } from "./chon-anh";
import { CHU_THICH_TOI_DA, KA_TEP_GOC_TOI_DA, TEN_NHOM_TOI_DA } from "../../../../src/shared/kho-anh";

const TRANG = 60;
const DUOI_NHAN = /\.(jpe?g|png|webp)$/i;
const MIME_NHAN = ["image/jpeg", "image/png", "image/webp"];
const maYeuCau = (): string => `ka-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
type TrangThaiTep = "cho" | "thu_nho" | "dang_tai" | "xong" | "trung" | "loi";
interface MucTai { f: File; ten: string; yc: string; tt: TrangThaiTep; loi?: string; mang?: boolean; dataUrl?: string }

export async function renderKhoAnh(root: HTMLElement): Promise<() => void> {
  const alive = gen("kho-anh");
  const laSuper = store.user?.role === "super";
  root.append(h("h1", {}, "Kho ảnh"));

  // ================= tải ảnh lên =================
  const chonTep = h("input", { type: "file", accept: "image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp", multiple: true, class: "sp-an-tep", tabindex: "-1", "aria-hidden": "true", "data-testid": "ka-chon-tep" }) as HTMLInputElement;
  const nutChon = h("button", { type: "button", "data-testid": "ka-chon", title: "Chọn một hoặc nhiều ảnh JPG / PNG / WebP trên máy" }, "Chọn ảnh…");
  const vung = h("div", { class: "sp-tha ka-tha", "data-testid": "ka-tha", tabindex: "0", title: "Kéo thả ảnh vào đây" },
    h("p", {}, h("b", {}, "Kéo-thả ảnh vào đây"), " hoặc ", nutChon, chonTep),
    h("p", { class: "small muted giai-thich" }, `Nhiều ảnh một lần · JPG, PNG, WebP · ảnh lớn tự thu nhỏ còn ≤ 1024 px trước khi gửi (tệp gốc tối đa ${Math.round(KA_TEP_GOC_TOI_DA / 1048576)} MB)`));
  const albumMoi = h("input", { maxlength: TEN_NHOM_TOI_DA, placeholder: "vd: Khuyến mãi tháng 10", list: "ka-ds-album", "data-testid": "ka-album-moi", title: "Album (thư mục) cho các ảnh sắp tải — không bắt buộc" });
  const nhanMoi = h("input", { maxlength: 200, placeholder: "vd: áo, hè (cách nhau dấu phẩy)", "data-testid": "ka-nhan-moi", title: "Nhãn cho các ảnh sắp tải — không bắt buộc" });
  const dsAlbum = h("datalist", { id: "ka-ds-album" });
  const hang = h("ul", { class: "ka-tai-ds", "data-testid": "ka-tai-ds" });
  const nutTai = h("button", { type: "button", class: "pri", disabled: true, "data-testid": "ka-tai", title: "Gửi các ảnh trong danh sách lên Kho ảnh" }, "Tải lên");
  const nutThuLai = h("button", { type: "button", hidden: true, "data-testid": "ka-thu-lai", title: "Gửi lại các ảnh chưa tải được (ảnh đã lên rồi không bị nhân đôi)" }, "Thử lại ảnh lỗi");
  const nutXoaDs = h("button", { type: "button", class: "mini", hidden: true, "data-testid": "ka-xoa-ds", title: "Bỏ danh sách chờ tải (không xoá ảnh đã lên kho)" }, "Bỏ danh sách");
  const ketQua = h("div", { "data-testid": "ka-tai-kq", role: "status" });
  root.append(h("div", { class: "card" }, h("h3", {}, "Tải ảnh lên"),
    h("p", { class: "small muted" }, "Ảnh trong kho dùng để bình luận / trả lời KÈM ẢNH: ở thẻ bước của kịch bản (hoặc Gói seeding) bấm “Chọn ảnh…”, tick nhiều ảnh — mỗi lần gửi bot lấy ngẫu nhiên một ảnh trong số đó."),
    vung,
    h("div", { class: "ka-tai-truong" }, h("label", { class: "f" }, h("span", {}, "Album cho ảnh mới"), albumMoi, dsAlbum), h("label", { class: "f" }, h("span", {}, "Nhãn cho ảnh mới"), nhanMoi)),
    hang, h("div", { class: "row" }, nutTai, nutThuLai, nutXoaDs), ketQua));

  let mucs: MucTai[] = [];
  let dangGui = false;
  const NHAN_TT: Record<TrangThaiTep, string> = { cho: "chờ tải", thu_nho: "đang thu nhỏ…", dang_tai: "đang tải lên…", xong: "✓ đã tải lên", trung: "✓ đã có trong kho (trùng nội dung — không thêm bản sao)", loi: "✗ chưa tải được" };
  function veHang(): void {
    clear(hang);
    for (const m of mucs) {
      const bo = m.tt === "cho" || m.tt === "loi" ? h("button", { type: "button", class: "mini", "data-testid": "ka-tai-bo", title: "Bỏ ảnh này khỏi danh sách chờ" }, "Bỏ") : null;
      bo?.addEventListener("click", () => { mucs = mucs.filter((x) => x !== m); veHang(); });
      hang.append(h("li", { class: `ka-tai-dong tt-${m.tt}`, "data-testid": "ka-tai-dong", dataset: { tt: m.tt } },
        h("span", { class: "ka-tai-ten" }, m.ten), h("span", { class: "small muted" }, kbChu(m.f.size)),
        h("span", { class: `small ka-tai-tt${m.tt === "loi" ? " err" : m.tt === "xong" || m.tt === "trung" ? " ok" : ""}`, "data-testid": "ka-tai-tt" }, m.tt === "loi" ? `${NHAN_TT.loi}: ${m.loi ?? ""}` : NHAN_TT[m.tt]), bo));
    }
    const cho = mucs.filter((m) => m.tt === "cho").length;
    const loi = mucs.filter((m) => m.tt === "loi" && m.mang).length;
    // Đang gửi: KHÔNG mở lại nút (lỗi thấy ở E2E K2: veHang trong lúc gửi bật lại nút → cú bấm thứ 2 chạy vòng gửi thứ 2 song song).
    nutTai.disabled = !cho || dangGui;
    nutTai.textContent = dangGui ? "Đang tải lên…" : cho ? `Tải lên ${cho} ảnh` : "Tải lên";
    nutThuLai.hidden = !loi || dangGui;
    nutThuLai.textContent = `Thử lại ${loi} ảnh lỗi mạng`;
    nutXoaDs.hidden = !mucs.length;
  }
  function nhanTep(files: File[]): void {
    clear(ketQua);
    for (const f of files) {
      const m: MucTai = { f, ten: f.name || "ảnh", yc: maYeuCau(), tt: "cho" };
      const dungLoai = MIME_NHAN.includes(f.type) || (!f.type && DUOI_NHAN.test(f.name));
      if (!dungLoai) { m.tt = "loi"; m.loi = "chỉ nhận ảnh JPG, PNG hoặc WebP (GIF, SVG, HEIC, tệp khác không nhận)"; }
      else if (f.size > KA_TEP_GOC_TOI_DA) { m.tt = "loi"; m.loi = `tệp quá lớn (${kbChu(f.size)}) — tối đa ${Math.round(KA_TEP_GOC_TOI_DA / 1048576)} MB trước khi thu nhỏ`; }
      else if (!f.size) { m.tt = "loi"; m.loi = "tệp rỗng (0 byte)"; }
      mucs.push(m);
    }
    veHang();
  }
  chonTep.addEventListener("change", () => { const f = [...(chonTep.files ?? [])]; chonTep.value = ""; nhanTep(f); });
  nutChon.addEventListener("click", () => chonTep.click());
  vung.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); chonTep.click(); } });
  vung.addEventListener("dragover", (e) => { e.preventDefault(); vung.classList.add("keo"); });
  vung.addEventListener("dragleave", () => vung.classList.remove("keo"));
  vung.addEventListener("drop", (e) => { e.preventDefault(); vung.classList.remove("keo"); nhanTep([...(e.dataTransfer?.files ?? [])]); });
  nutXoaDs.addEventListener("click", () => { mucs = mucs.filter((m) => m.tt === "dang_tai" || m.tt === "thu_nho"); clear(ketQua); veHang(); });

  async function guiDanhSach(chon: (m: MucTai) => boolean): Promise<void> {
    if (dangGui) return; // một vòng gửi tại một lúc
    dangGui = true;
    veHang();
    try { await guiDanhSach1(chon); } finally { dangGui = false; if (alive()) veHang(); }
  }
  async function guiDanhSach1(chon: (m: MucTai) => boolean): Promise<void> {
    const ds = mucs.filter(chon);
    let len = 0, trung = 0, loi = 0, matMang = 0;
    for (const m of ds) {
      if (!alive()) return;
      try {
        if (!m.dataUrl) { m.tt = "thu_nho"; veHang(); m.dataUrl = await thuNhoAnh(m.f); }
        m.tt = "dang_tai"; m.loi = undefined; m.mang = false; veHang();
        const r = await api<{ anh: AnhKhoWeb; trung: boolean }>("POST", "/api/kho-anh", { anh: m.dataUrl, tenTep: m.ten, album: albumMoi.value, nhan: nhanMoi.value, yeuCauId: m.yc });
        m.tt = r.trung ? "trung" : "xong";
        if (r.trung) trung++; else len++;
      } catch (e) {
        m.tt = "loi";
        m.mang = e instanceof ApiError && e.code === "network";
        m.loi = m.mang ? "mất mạng — chưa gửi được (bấm “Thử lại ảnh lỗi” khi có mạng)" : errMsg(e).replace(/^Ảnh “[^”]*” /, "");
        if (m.mang) matMang++; else loi++;
      }
      veHang();
    }
    clear(ketQua);
    const tomTat = [len ? `Đã tải lên ${len} ảnh` : "", trung ? `${trung} ảnh đã có sẵn trong kho (không thêm bản sao)` : "", loi ? `${loi} ảnh lỗi (xem từng dòng)` : "", matMang ? `${matMang} ảnh CHƯA tải vì mất mạng — kiểm tra mạng rồi bấm “Thử lại ảnh lỗi”` : ""].filter(Boolean).join(" · ");
    if (tomTat) ketQua.append(h("div", { class: matMang || loi ? "warn-box" : "ok-box", "data-testid": "ka-tai-tom-tat" }, `${tomTat}.`));
    if (matMang) toast(`Mất mạng: ${matMang} ảnh chưa tải được`, "err");
    if (len) { before = null; await taiLuoi(true); await taiNhom(); }
  }
  nutTai.addEventListener("click", () => void guiDanhSach((m) => m.tt === "cho")); // nút tự khoá qua dangGui (không dùng busy: busy trả lại chữ cũ "Tải lên N ảnh" sau khi xong)
  nutThuLai.addEventListener("click", () => void guiDanhSach((m) => m.tt === "loi" && !!m.mang));

  // ================= lưới ảnh =================
  const tim = h("input", { type: "search", placeholder: "Tìm theo chú thích, tên tệp, nhãn…", maxlength: 80, "data-testid": "ka-tim", "aria-label": "Tìm ảnh" });
  const loc = h("select", { "data-testid": "ka-loc", "aria-label": "Lọc theo nguồn / album / sản phẩm" }, h("option", { value: "" }, "Mọi ảnh"), h("option", { value: "nguon:tai_len" }, "Ảnh tải lên"), h("option", { value: "nguon:san_pham" }, "Ảnh sản phẩm"));
  const locNhan = h("select", { "data-testid": "ka-loc-nhan", "aria-label": "Lọc theo nhãn" }, h("option", { value: "" }, "Mọi nhãn"));
  const locChu = laSuper ? h("input", { placeholder: "Mã tài khoản (bỏ trống = mọi Boss)", "data-testid": "ka-loc-chu", maxlength: 80, "aria-label": "Lọc theo tài khoản" }) : null;
  const dem = h("span", { class: "small muted", "data-testid": "ka-dem", role: "status" });
  const luoi = h("div", { class: "ka-luoi", "data-testid": "ka-luoi" });
  const them = h("button", { type: "button", hidden: true, "data-testid": "ka-xem-them", title: "Tải thêm các ảnh cũ hơn" }, "Tải thêm");
  root.append(h("div", { class: "card" }, h("div", { class: "row between wrap" }, h("h3", {}, laSuper ? "Ảnh của mọi Boss" : "Ảnh trong kho"), dem),
    h("div", { class: "row ka-loc-hang" }, tim, loc, locNhan, locChu), luoi, h("div", { class: "row center" }, them)));

  async function taiNhom(): Promise<void> {
    try {
      const n = await api<NhomKho>("GET", `/api/kho-anh/nhom${buildQuery({ ownerId: locChu?.value.trim() || null })}`);
      if (!alive()) return;
      const giuLoc = loc.value, giuNhan = locNhan.value;
      while (loc.options.length > 3) loc.remove(3);
      for (const a of n.album) loc.append(h("option", { value: `album:${a.ten}` }, `Album: ${a.ten} (${a.so})`));
      for (const s of n.sanPham) loc.append(h("option", { value: `sp:${s.id}` }, `Sản phẩm: ${s.ten} (${s.so})`));
      loc.value = [...loc.options].some((o) => o.value === giuLoc) ? giuLoc : "";
      while (locNhan.options.length > 1) locNhan.remove(1);
      for (const a of n.nhan) locNhan.append(h("option", { value: a.ten }, `${a.ten} (${a.so})`));
      locNhan.value = [...locNhan.options].some((o) => o.value === giuNhan) ? giuNhan : "";
      clear(dsAlbum);
      for (const a of n.album) dsAlbum.append(h("option", { value: a.ten }));
    } catch { /* bộ lọc nhóm không bắt buộc */ }
  }

  function the(a: AnhKhoWeb): HTMLElement {
    const laSp = a.nguon === "san_pham";
    const luu = async (body: Record<string, unknown>, o: HTMLInputElement): Promise<void> => {
      o.classList.remove("kb-sai");
      try {
        const moi = await api<AnhKhoWeb>("PUT", `/api/kho-anh/${encodeURIComponent(a.id)}`, body);
        Object.assign(a, moi);
        o.dataset.goc = o.value = body.moTa !== undefined ? moi.moTa : body.album !== undefined ? moi.album : moi.nhan.join(", ");
        toast("Đã lưu", "info", 1500);
        if (body.album !== undefined || body.nhan !== undefined) void taiNhom();
      } catch (e) { o.classList.add("kb-sai"); toast(`Chưa lưu được: ${errMsg(e)}`, "err"); }
    };
    const o = (giaTri: string, attrs: Record<string, unknown>, khoa: "moTa" | "album" | "nhan"): HTMLInputElement => {
      const inp = h("input", { value: giaTri, ...attrs }) as HTMLInputElement;
      inp.dataset.goc = giaTri;
      const gui = (): void => { if (inp.value !== inp.dataset.goc) { inp.dataset.goc = inp.value; void luu({ [khoa]: inp.value }, inp); } };
      inp.addEventListener("change", gui);
      inp.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); gui(); } });
      return inp;
    };
    const moTa = o(a.moTa, { maxlength: CHU_THICH_TOI_DA, placeholder: "Chú thích (bot đọc khi cần)", "data-testid": "ka-mo-ta", "aria-label": `Chú thích ảnh ${a.tenTep || a.id}` }, "moTa");
    const album = laSp ? null : o(a.album, { maxlength: TEN_NHOM_TOI_DA, placeholder: "Album", list: "ka-ds-album", "data-testid": "ka-album", "aria-label": `Album của ảnh ${a.tenTep}` }, "album");
    const nhan = laSp ? null : o(a.nhan.join(", "), { maxlength: 200, placeholder: "Nhãn (cách nhau dấu phẩy)", "data-testid": "ka-nhan", "aria-label": `Nhãn của ảnh ${a.tenTep}` }, "nhan");
    const xoa = laSp ? null : h("button", { type: "button", class: "mini danger", "data-testid": "ka-xoa", "aria-label": `Xoá ảnh ${a.tenTep}`, title: "Xoá ảnh này khỏi Kho ảnh" }, "Xoá");
    const fig = h("figure", { class: "ka-anh", "data-testid": "ka-anh", dataset: { id: a.id, nguon: a.nguon } },
      h("a", { href: a.url, target: "_blank", rel: "noopener", title: "Mở ảnh cỡ thật" }, h("img", { src: a.url, alt: tenHienAnh(a), loading: "lazy" })),
      h("figcaption", {},
        h("span", { class: "ka-anh-ten", "data-testid": "ka-anh-ten", title: a.tenTep }, laSp ? `Sản phẩm: ${a.spTen ?? ""}` : a.tenTep),
        h("span", { class: "small muted" }, `${a.rong}×${a.cao} · ${kbChu(a.kichThuoc)} · ${fmtTime(a.taoLuc)}${laSuper && a.ownerName ? ` · ${a.ownerName}` : ""}`),
        moTa, album, nhan,
        laSp ? h("a", { class: "small", href: `#/san-pham/${encodeURIComponent(a.spId ?? "")}`, title: "Thêm / bỏ ảnh sản phẩm ở trang Sản phẩm" }, "Sửa ở trang Sản phẩm") : null,
        xoa));
    xoa?.addEventListener("click", () => void busy(xoa, "Đang xoá…", async () => {
      // Hỏi MỘT lần, nêu luôn kịch bản đang chọn ảnh này (máy chủ trả danh sách trước) rồi xoá với dongY=1.
      let dung: { id: string; ten: string }[] = [];
      try { dung = (await api<{ kichBan: { id: string; ten: string }[] }>("GET", `/api/kho-anh/${encodeURIComponent(a.id)}/dung`)).kichBan; }
      catch (e) { toast(`Chưa xoá được: ${errMsg(e)}`, "err"); return; }
      const canhBao = dung.length
        ? ` Ảnh đang được ${dung.length} kịch bản chọn để kèm bình luận: ${dung.slice(0, 5).map((k) => `“${k.ten}”`).join(", ")}${dung.length > 5 ? "…" : ""} — xoá thì các bước đó bỏ ảnh này (bot chọn trong các ảnh còn lại; hết ảnh thì gửi chỉ chữ / bỏ câu theo cài đặt của bước).`
        : "";
      if (!(await confirmBox({ title: dung.length ? "Ảnh đang được dùng — vẫn xoá?" : "Xoá ảnh khỏi Kho ảnh?", text: `“${a.tenTep}”${a.moTa ? ` — ${a.moTa}` : ""}. Xoá rồi không lấy lại được.${canhBao}`, okText: dung.length ? "Vẫn xoá" : "Xoá ảnh", danger: true }))) return;
      try { await api("DELETE", `/api/kho-anh/${encodeURIComponent(a.id)}?dongY=1`); } catch (e) { toast(`Chưa xoá được: ${errMsg(e)}`, "err"); return; }
      fig.remove();
      tong = Math.max(0, tong - 1);
      veDem();
      toast("Đã xoá ảnh");
      void taiNhom();
    }));
    return fig;
  }

  let before: string | null = null;
  let tong = 0;
  let theHe = 0;
  let dangTai = false;
  const veDem = (): void => { dem.textContent = `${tong} ảnh`; };
  async function taiLuoi(dau: boolean): Promise<void> {
    if (dangTai && !dau) return;
    const so = ++theHe;
    dangTai = true;
    const l = loc.value;
    try {
      const r = await api<{ items: AnhKhoWeb[]; nextBefore: string | null; tong: number }>("GET", `/api/kho-anh${buildQuery({
        limit: TRANG, before: dau ? null : before, q: tim.value.trim() || null, ownerId: locChu?.value.trim() || null, nhan: locNhan.value || null,
        nguon: l.startsWith("nguon:") ? l.slice(6) : null, album: l.startsWith("album:") ? l.slice(6) : null, spId: l.startsWith("sp:") ? l.slice(3) : null,
      })}`);
      if (!alive() || so !== theHe) return;
      if (dau) clear(luoi);
      tong = r.tong;
      veDem();
      if (dau && !r.items.length) luoi.append(h("p", { class: "empty", "data-testid": "ka-trong" }, tim.value.trim() || l || locNhan.value ? "Không có ảnh nào khớp." : "Chưa có ảnh nào — kéo-thả ảnh vào khung “Tải ảnh lên” ở trên."));
      for (const a of r.items) luoi.append(the(a));
      before = r.nextBefore;
      them.hidden = !before;
      them.textContent = `Tải thêm (còn ${Math.max(0, tong - luoi.querySelectorAll(".ka-anh").length)} ảnh)`;
    } catch (e) {
      if (so === theHe) { if (dau) clear(luoi); luoi.append(h("div", { class: "err-box", "data-testid": "ka-loi-tai" }, `Không tải được ảnh: ${errMsg(e)}`)); }
    } finally { if (so === theHe) dangTai = false; }
  }
  let hen: number | undefined;
  const taiLai = (): void => { window.clearTimeout(hen); hen = window.setTimeout(() => void taiLuoi(true), 250); };
  tim.addEventListener("input", taiLai);
  locChu?.addEventListener("input", () => { taiLai(); void taiNhom(); });
  loc.addEventListener("change", () => void taiLuoi(true));
  locNhan.addEventListener("change", () => void taiLuoi(true));
  them.addEventListener("click", () => void busy(them, "Đang tải…", () => taiLuoi(false)));
  // cuộn tới cuối lưới → tự tải trang sau (1000+ ảnh)
  const quan = typeof IntersectionObserver === "function" ? new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting) && !them.hidden && !dangTai) void taiLuoi(false); }, { rootMargin: "300px" }) : null;
  quan?.observe(them);

  await Promise.all([taiNhom(), taiLuoi(true)]);
  return () => { window.clearTimeout(hen); quan?.disconnect(); };
}
